function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M380.9,126H131.1c-6.9,0-12.5,4.5-12.5,10v20c0,5.5,5.6,10,12.5,10h249.7c6.9,0,12.5-4.5,12.5-10v-20 C393.4,130.5,387.8,126,380.9,126z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M380.9,236H131.1c-6.9,0-12.5,4.5-12.5,10v20c0,5.5,5.6,10,12.5,10h249.7c6.9,0,12.5-4.5,12.5-10v-20 C393.4,240.5,387.8,236,380.9,236z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M253.3,346H124c-3.6,0-6.4,4.5-6.4,10v20c0,5.5,2.9,10,6.4,10h129.1c3.6,0,6.4-4.5,6.4-10v-20 C259.7,350.5,256.9,346,253.3,346z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M511.5,360.3V53.9c0-30.3-24.6-54.9-54.9-54.9H54.4C24.1-1-0.5,23.6-0.5,53.9v402.3c0,30.3,24.6,54.9,54.9,54.9h306.4 c14.5,0,28.5-5.8,38.8-16.1l95.9-95.9C505.7,388.8,511.5,374.8,511.5,360.3z M373.7,469.1c-2.3,2.3-5.3,4-8.5,4.8V364.7h109.2 c-0.8,3.2-2.5,6.2-4.8,8.5L373.7,469.1z M474.9,53.9v274.3H356.1c-15.1,0-27.4,12.3-27.4,27.4v118.9H54.4 c-10.1,0-18.3-8.2-18.3-18.3V53.9c0-10.1,8.2-18.3,18.3-18.3h402.3C466.7,35.6,474.9,43.8,474.9,53.9z"
});

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.0ebff683.svg";
export { ForwardRef as ReactComponent };